<template>
	<v-card outlined>
		<v-card-text>
			<v-row no-gutters>
				<template v-for="(item, key, index) of info_show">					
					<v-col 
						:key="index"
						:md="col_render(key)" 
						:order="order_render(key)"
						v-if="filter_key(key)"
					>
						<v-card outlined v-show="key=='full_photo_url'">
							<v-img 
								:src="`${$URL}/${item}`" 
								@click="redirect_img(item)" 
								height="100%"
								width="100%"  
								aspect-ratio="1.4" 
								contain
							/></v-img>	
							<!-- 'http://'+${$localhost}+':'+this.$port+''+ -->
						</v-card>
						<v-card outlined v-if="key!=='full_photo_url'" height="100%">
							
									<v-card-title
										class="justify-center body-2 secondary white--text pa-1"							
									>
										<strong >{{ key }} :</strong>
									</v-card-title>
																
									<v-card-text class="pa-0">
										<span 
											v-if="key=='host' && item && item.name"
										>
											{{item.name}}
										</span>
										<span 
											v-else="key!=='host'"
										>
											{{item}}
										</span>
									</v-card-text>
							
						</v-card>
					</v-col>
				</template>
			</v-row>
		</v-card-text>
	</v-card>
</template>
<script>
	export default{
		name: 'show_data_info',
		props: ['info_show'],
		data: () => ({

		}), // data

		methods:{
			redirect_img(v){
				window.open(this.$URL + '/'+v,'_blank');
				// 
			},
			order_render(val){
				
				switch (val){
					case 'full_photo_url': return '1';
					case 'id': return '2';
					case 'category': return '3';
					case 'host': return '4';
					case 'device': return '4';
					case 'probability': return '5';
					case 'timestamp': return '6';
					
				}

			}, // order render

			filter_key(key){
				if (
					key=='full_photo_url' || 
					key=='id' ||
					key=='host' || 
					key=='device' ||
					key=='tags' || 
					key=='category' || 
					key=='probability' || 
					key=='timestamp'
				){
					return true;
				}else{
					 return false;
				}
			}, // filter key
			col_render(key_col){
				switch (key_col){
					case 'full_photo_url': return 12;
					case 'id': return 6;
					case 'category': return 6;
					case 'host': return 12;
					case 'device': return 12;
					case 'probability': return 6;
					case 'timestamp': return 6;
					
				}
			},
		}, // methods
	};
</script>